import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-39d1c499"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "trade-product-item"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "product-name"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("/USDT");

const _hoisted_5 = {
  class: "product-price"
};
const _hoisted_6 = {
  key: 0,
  class: "star"
};
import { fmtImageSrc } from '@/util';
import store from '@/store';
import { fmtNumber } from '@/util';
import { StarOutlined, StarFilled } from '@ant-design/icons-vue';
export default {
  __name: 'TradeProductItem',
  props: {
    name: {
      type: String,
      default: ''
    },
    last: {
      type: String,
      default: '0.00'
    },
    up: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    },
    starShow: {
      type: Boolean,
      default: false
    },
    indices: {
      type: Boolean,
      default: false
    }
  },

  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
        src: _unref(fmtImageSrc)(props.icon),
        width: "25",
        height: "25",
        round: ""
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, [_createTextVNode(_toDisplayString(_unref(store).state.marketInfo[props.name]?.name), 1), props.indices == false ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_4], 64)) : _createCommentVNode("", true)])]), _createElementVNode("span", _hoisted_5, [_createElementVNode("div", {
        style: _normalizeStyle({
          color: __props.up ? '#04AC92' : '#EC2752'
        })
      }, _toDisplayString(_unref(fmtNumber)(props.last)), 5), props.id != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [props.starShow ? (_openBlock(), _createBlock(_unref(StarFilled), {
        key: 0,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _unref(store).commit('addStar', {
          id: props.id,
          select: 0
        }), ["stop"]))
      })) : (_openBlock(), _createBlock(_unref(StarOutlined), {
        key: 1,
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => _unref(store).commit('addStar', {
          id: props.id,
          select: 1
        }), ["stop"]))
      }))])) : _createCommentVNode("", true)])]);
    };
  }

};